module.exports = __webpack_public_path__ + "static/media/eirtech.ffcc2739.png";